// Packages and components
import React, { useEffect, useState } from 'react';
import { Box } from 'grommet';
import SHDText from '@ui/Text/SHDText';

// Types and interfaces
import { CaptureStatus } from './camera-selection.d';
import type { CameraStatusProps } from './camera-selection.d';

const CameraStatus: React.FC<CameraStatusProps> = ({
  status,
  targetTeamName,
}) => {
  const [statusText, setStatusText] = useState<string>('');
  const [statusColor, setStatusColor] = useState<string>('');

  useEffect(() => {
    switch (status) {
      case CaptureStatus.Ready:
        setStatusText('Ready');
        setStatusColor('primary');
        break;
      case CaptureStatus.Disabled:
        setStatusText('Disabled');
        setStatusColor('gray-500');
        break;
      case CaptureStatus.OtherTeam:
        setStatusText(`Currently enabled for ${targetTeamName}`);
        setStatusColor('gray-500');
        break;
      case CaptureStatus.Live:
      case CaptureStatus.TeamLive:
        setStatusText('Live');
        setStatusColor('dk-red');
        break;
      default:
        setStatusText('');
        setStatusColor('');
    }
  }, [status, targetTeamName]);

  return (
    <>
      <Box
        align="center"
        className="capture-status"
        gap="xxxsmall"
        direction="row"
      >
        <Box
          background={statusColor}
          className="capture-status__indicator"
          height="8px"
          round="full"
          width="8px"
        ></Box>
        <SHDText style="body" color="black-alpha-80">
          {statusText}
        </SHDText>
      </Box>
    </>
  );
};

export default CameraStatus;
